import { Component, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { ThemeService }    from '@aurrica-web/core-data';
import {
  LANDING_FLEET_LOGIN_URL,
  LANDING_FREIGHT_LOGIN_URL,
} from '../landing-app-links';

import { HeroHeadlineWideComponent }   from '../hero-headline-wide/hero-headline-wide';

@Component({
  selector: 'app-hero-section',
  standalone: true,
  imports: [TranslocoModule, HeroHeadlineWideComponent],
  templateUrl: './hero-section.html',
  styles: [`:host { display: block; }`],
})
export class HeroSectionComponent {
  themeService = inject(ThemeService);
  protected readonly freightLoginUrl = LANDING_FREIGHT_LOGIN_URL;
  protected readonly fleetLoginUrl = LANDING_FLEET_LOGIN_URL;
  onMagnet(e: MouseEvent): void {
    const el = e.currentTarget as HTMLElement;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--btn-x', `${(e.clientX - rect.left - rect.width  / 2) * 0.28}px`);
    el.style.setProperty('--btn-y', `${(e.clientY - rect.top  - rect.height / 2) * 0.28}px`);
  }

  onMagnetLeave(e: MouseEvent): void {
    const el = e.currentTarget as HTMLElement;
    el.style.setProperty('--btn-x', '0px');
    el.style.setProperty('--btn-y', '0px');
  }
}
